var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardTool = function SvgIconDashboardTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "#9E1F63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 12h-2c-2.48 0-4.5 2.02-4.5 4.5v2c0 2.48 2.02 4.5 4.5 4.5h2c2.48 0 4.5-2.02 4.5-4.5v-2c0-2.48-2.02-4.5-4.5-4.5m1.5 6.5c0 .83-.67 1.5-1.5 1.5h-2c-.83 0-1.5-.67-1.5-1.5v-2c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5zM31.5 25h-2c-2.48 0-4.5 2.02-4.5 4.5v2c0 2.48 2.02 4.5 4.5 4.5h2c2.48 0 4.5-2.02 4.5-4.5v-2c0-2.48-2.02-4.5-4.5-4.5m1.5 6.5c0 .83-.67 1.5-1.5 1.5h-2c-.83 0-1.5-.67-1.5-1.5v-2c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5zM18.5 25h-2c-2.48 0-4.5 2.02-4.5 4.5v2c0 2.48 2.02 4.5 4.5 4.5h2c2.48 0 4.5-2.02 4.5-4.5v-2c0-2.48-2.02-4.5-4.5-4.5m1.5 6.5c0 .83-.67 1.5-1.5 1.5h-2c-.83 0-1.5-.67-1.5-1.5v-2c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5zm5-16.48c0-1.67 1.23-3.02 2.75-3.02 1.34 0 2.5 1.05 2.74 2.44.25-1.39 1.42-2.44 2.76-2.44 1.52 0 2.75 1.35 2.75 3.02 0 2.38-3.1 5.44-4.65 6.68-.5.4-1.21.4-1.71 0-1.54-1.24-4.65-4.3-4.65-6.68z"
  })));
};
export default SvgIconDashboardTool;